import { User, VoucherType } from '../../../types'
import { Link } from 'react-router-dom'
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'
import { GenericColumnDef } from '../DataTable'
import VoucherStateBadge from '../VoucherStateBadge'
import { getLatestApprovingUser, formatPeriod, formatPaymentDate } from '../../../utils/utils'

export const getInboxColumns = (): GenericColumnDef<VoucherType>[] => [
  {
    id: 'expander',
    header: () => null,
    cell: ({ row }) =>
      row.getCanExpand() ? (
        <button
          onClick={row.getToggleExpandedHandler()}
          style={{ cursor: 'pointer', border: 'none', background: 'none' }}
        >
          {row.getIsExpanded() ? (
            <FaCaretDown className="text-primary" />
          ) : (
            <FaCaretRight className="text-primary" />
          )}
        </button>
      ) : null,
    size: 40,
  },
  {
    accessorKey: 'reference_number',
    header: 'Reference #',
    cell: ({ row }) => (
      <Link to={`/panel/inbox/${row.original.id}/edit`}>
        {row.original.reference_number}
      </Link>
    ),
    enableColumnFilter: false,
    size: 20,
  },
  { accessorFn: (row) => row.department.name, header: 'Department', size: 20 },
  {
    accessorFn: (row) =>
      new Date(row.created_at * 1).toISOString().split('T')[0],
    header: 'Created At',
    enableColumnFilter: false,
    size: 80,
  },
  {
    accessorFn: (row) =>
      row.created_by.first_name + ' ' + row.created_by.last_name,
    header: 'Prepared by',
    size: 200,
  },
  {
    accessorKey: 'state',
    header: 'State',
    cell: ({ row }) => <VoucherStateBadge state={row.original.state} />,
    size: 10,
  },
  {
    accessorFn: (row) => row.pay_to,
    header: 'Pay amount to',
    size: 200,
  },
  {
    accessorFn: (row: VoucherType) => {
      const approver = getLatestApprovingUser(row)
      return approver ? `${approver.first_name} ${approver.last_name}` : ''
    },
    header: 'Last Approval',
  },
  {
    accessorFn: (row) => formatPaymentDate(row.paid_by_amin),
    header: 'Payment',
    enableColumnFilter: false,
    size: 80,
  },
  {
    accessorFn: (row) => formatPeriod(row.expense_period),
    header: 'Expense Month',
    enableColumnFilter: false,
    size: 80,
  },
  {
    accessorFn: (row) => `${row.total_amount.toFixed(2)} ${row.currency}`,
    header: 'Amount',
    enableColumnFilter: false,
    meta: { align: 'right' },
    size: 120,
  },
]
